import * as React from 'react';
import { connect } from 'react-redux';

import { IApplicationState } from '../../../types/redux';

import { CityModal } from './CityModal/CityModal';
import { Container } from '../../../components/Container';
import { Button } from '../../../components/Button';
import { Modal } from '../../../components/Modal';
import { SIZE_WIDE } from '../../../constants/sizes';
import { TTypedThunkDispatch } from '../../../types/thunk';
import { trackingActionPopupGeoOpen } from '../../../actions/analytics';
import { getOffersCount } from '../../../actions/offersData';

interface IModalStoreProps {
  regionName: string;
}

interface IModalDispatchProps {
  trackingPopupGeoOpen(): void;
  getOffersCount(): void;
}

interface IModalState {
  isOpen: boolean;
  isOpenSuggest: boolean;
}

type TModalProps = IModalStoreProps & IModalDispatchProps;

class LocationModalComponent extends React.PureComponent<TModalProps, IModalState> {
  public state: Readonly<IModalState> = {
    isOpen: false,
    isOpenSuggest: false,
};

  public render() {
    const {
      regionName,
    } = this.props;
    const {
      isOpen,
    } = this.state;

    return (
      <Container>
        <Modal
          onChange={this.handleOpenModal}
          isOpen={isOpen}
          component={
            <Container
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              height={SIZE_WIDE}
              maxHeight="80vh"
            >
              <CityModal
                onSubmitModal={this.handleSubmit}
                onToggleSuggest={this.handleToggleSuggest}
              />
            </Container>
          }
        >
          <Button normalText={true} type="light" tabIndex={-1} >{regionName}</Button>
        </Modal>
      </Container>
    );
  }

  private handleToggleSuggest = (isOpenSuggest: boolean) => {
    this.setState({ isOpenSuggest });
  }

  private handleOpenModal = (isOpen: boolean) => {
    if (isOpen) {
      this.props.trackingPopupGeoOpen();
    } else {
      this.props.getOffersCount();
    }
    this.setState({ isOpen });
  }

  private handleSubmit = () => {
    this.setState({ isOpen: false });
  }
}

function mapStateToProps(state: IApplicationState): IModalStoreProps {
  return {
    regionName: state.region.currentRegion.displayName,
  };
}

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    trackingPopupGeoOpen() {
      dispatch(trackingActionPopupGeoOpen());
    },
    getOffersCount() {
      dispatch(getOffersCount());
    },
  };
}

export const LocationModal = connect(mapStateToProps, mapDispatchToProps)(LocationModalComponent);
